import React, { useState } from 'react'

export type SearchFormContextType<T> = {
  updateFormValues: (formValues: T) => void
  formValues: T
}

export const SearchFormContext = React.createContext({} as unknown)

function SearchFormProvider({
  children
}: {
  children: JSX.Element | JSX.Element[]
}) {
  const [formValues, updateFormValues] = useState({} as unknown)

  return (
    <SearchFormContext.Provider value={{ formValues, updateFormValues }}>
      {children}
    </SearchFormContext.Provider>
  )
}

export default SearchFormProvider
